import React from "react";
import { useDispatch } from "react-redux";
import { ClientPerson } from "../../types";
import { getClientPerson } from "../../thunks/clientPerson/loadClientPerson";

export const useClientPerson = (clientPerosnId?: string) => {
	const displatch = useDispatch();
	const [client, setClient] = React.useState<ClientPerson | undefined>();

	React.useEffect(() => {
		const loadClient = async () => {
			if (clientPerosnId) {
				const loadedClient = (await displatch(getClientPerson(clientPerosnId))) as any;
				setClient(loadedClient);
			}
		};
		loadClient();
	}, [displatch, clientPerosnId, setClient]);

	return [client];
};
